"use strict";

class AuthLostPasswordCtrl {

    /**
     * [constructor description]
     * @param  {[type]} $http [description]
     * @return {[type]}       [description]
     */
    constructor($http) {

        let csrftoken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

        this.$http = $http;

        // Defaults
        this.formdata = {
            email: null,
            _token: csrftoken
        };

        this.status = {
            error: false,
            sending: false,
            // If send, display message to user
            send: false
        };

//		$document.querySelector('#email').focus();
    }

    /**
     * [submit description]
     * @param  {Boolean} isValid [description]
     * @return {[type]}          [description]
     */
    submit(isValid) {

        if (!isValid) {

            return;
        }

        this.status.sending = true;
        this.status.error = false;

        this.$http.post('/password/email', this.formdata)
            .then(() => {

                // Login successfull!
                this.status.sending = false;
                this.status.send = true;
            })
            .catch((response) => {
                this.status.message = response.data.email;
                this.status.error = true;
                this.status.sending = false;
            });
    }
}

AuthLostPasswordCtrl.$inject = ['$http'];

module.exports = AuthLostPasswordCtrl;

